<template>
  <div class="chart-container">
    <div v-if="isDashboardLoading" class="chart">
      <vue-simple-spinner size="massive" />
    </div>
    <div v-else-if="dashboardSummary.length > 0" class="chart">
      <dashboard-table :title="title" :summary="dashboardSummary" class="dashboard-table" />
    </div>
  </div>
</template>
<script>
import { AssignmentsListingGetters } from '@/app/features/assignments/features/assignments-listing/assignments-listing.keys';
import DashboardTable from '@/app/components/DashboardTable.vue';

export default {
  name: 'PlacementActivityChart',
  components: {
    DashboardTable
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    dashboardSummary() {
      return this.$store.getters[AssignmentsListingGetters.DashboardSummary];
    },
    isDashboardLoading() {
      return this.$store.getters[AssignmentsListingGetters.IsDashboardLoading];
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/app/styles/colors.scss';

.chart-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 40px;
  width: 100%;
  .title {
    font-size: 1rem;
    border-bottom: 1px solid $row-border;
  }
  .chart {
    background-color: $white;
  }
  .dashboard-table {
    display: inline-block;
    border-collapse: collapse;
    padding: 10px;
    margin: 10px;
  }
}
</style>
